import { getV1Access, isHijackSession } from './authV1';
import { getCookie } from './manageCookie';

export default function getAuthorizationHeaders() {
  const v1Access = getV1Access();
  if (v1Access && !isHijackSession()) {
    return { Authorization: `Bearer ${v1Access}` };
  }
  // Django session auth (hijack, or no store JWT) needs CSRF on unsafe requests
  return { 'X-CSRFToken': getCookie('csrftoken') };
}
